<template>
  <div class="pay-type-display" v-if="!isForeman()">
    <span v-if="data.pay_type === 'Price'">
      {{ data.pay_type }}
    </span>
    <span v-else>
      {{ data.pay_type }} ({{ data.pay_amount | currency }})
    </span>
  </div>
  <div v-else>
    {{ data.pay_type }}
  </div>
</template>

<script>
import {isForeman} from "../shared/index";

export default {
  name: 'Rate',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isForeman
  }
};
</script>
